import React from "react";
import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { oktaConfig } from "./Okta/oktaConfig";
import { RouterProviderWrapper } from "./Router/Router";

const oktaAuth = new OktaAuth(oktaConfig);

function AppWrapper() {
  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    window.location.replace(toRelativeUrl(originalUri || "/", window.location.origin));
  };
  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <RouterProviderWrapper />
    </Security>
  );
}

export default AppWrapper;
